import { find } from 'lodash';

export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN',
};

export const GAME = {
  name: 'Sevimli Dostlar',
  platform: process.env.REACT_APP_USE_EMULATOR === 'true' ? 'Emulator Mode' : process.env.REACT_APP_NODE_ENV,
};

export const COMPANY = {
  emailCheck: {
    regex: /^[A-Za-z0-9._%+-]+@(adisebaba.com|diyojen.io)$/,
    text: 'Only authorized emails',
  },
};

export const PLATFORM_OPTIONS = [
  {
    value: 'playstore',
    text: 'PlayStore',
  },
  {
    value: 'appstore',
    text: 'AppStore',
  },
];

export const getPlatformLabel = platform => {
  return find(PLATFORM_OPTIONS, { value: platform }).text;
};
